import React, { useEffect } from "react";
import ManagerDashboardHeader from "../Header/ManagerDashboardHeader";
import { Box, Stack } from "@mui/material";
import styles from "../../styles/layout/managerdashboard/manager-dashboard-wrapper.module.scss";
import { ManagerDashboardSidebar } from "../Sidebar/ManagerDashboardSidebar";
import UserCopyWriterFooter from "../UserFooter/UserCopyWriterFooter";
import { Navigate, useNavigate } from "react-router";
import { parseCookies } from "nookies";
import { useAppSelector } from "../../hooks/useAppSelector";

export default function ManagerDashboardWapper(props) {
  const cookies = parseCookies();
  const savedrole_Id = cookies?.role_id;
  const { userData } = useAppSelector((s) => s.userSlice);


  const nav = useNavigate();

  useEffect(() => {
    if (savedrole_Id != 7) {
      //   <Navigate to="/page404" />;
      // nav("/page404");
      nav("/login");
    } else {
      return;
    }
  }, [savedrole_Id]);

  return (
    <>
      <ManagerDashboardHeader />
      <Stack direction={"row"} className={styles.managerDashboardSiderbarBody}>
        <Box className={styles.managerDashboardSidebar}>
          <ManagerDashboardSidebar />
        </Box>
        <Box className={styles.managerDashboardBody}>{props.children}</Box>
      </Stack>
      <UserCopyWriterFooter footerChatBtn={props.chatbtn} />
    </>
  );
}
